module.exports = {"title":"account_recover_form","type":"object","properties":{"email":{"type":"string","pattern":"^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"}},"required":["email"]}


//////////////////
// WEBPACK FOOTER
// ./src/shared/json_schemas/userRecoverForm.json
// module id = 859
// module chunks = 0